export default {
  minLength: 8,
  notUsername: true,
  notEmail: true,
};
